import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Routes } from '../App';
import { useAppParams } from '../hooks/app-params.hook';
import { useNavigation } from '../hooks/navigation.hook';
import { useSift } from '../hooks/sift.hook';
import { isNode } from '../util/utils';
import { Navigation } from './navigation';
export function Layout({ title, backButton, onBack, textStart, children, rootRef, scrollRef, noPadding, }) {
    useSift();
    const navRef = useRef(null);
    const [isNavigationOpen, setIsNavigationOpen] = useState(false);
    const { pathname } = useLocation();
    const { clearParams } = useNavigation();
    const { headless, borderless } = useAppParams();
    useEffect(() => {
        const kycRoutes = Routes.filter((r) => r.isKycScreen);
        if (!kycRoutes.some((r) => pathname === r.path))
            clearParams(['code']);
    }, [pathname]);
    function onClick(e) {
        if (isNavigationOpen && isNode(e.target) && navRef.current && !navRef.current.contains(e.target)) {
            setIsNavigationOpen(false);
        }
    }
    return (_jsxs("div", Object.assign({ id: "app-root", className: "h-full flex flex-col", ref: rootRef, onClick: onClick }, { children: [headless !== 'true' && (_jsx(Navigation, { ref: navRef, title: title, backButton: backButton, onBack: onBack, isOpen: isNavigationOpen, setIsOpen: setIsNavigationOpen })), _jsx("div", Object.assign({ className: "flex flex-col flex-grow overflow-auto", ref: scrollRef }, { children: _jsx("div", Object.assign({ className: "flex flex-grow justify-center" }, { children: _jsx("div", Object.assign({ className: `relative w-full max-w-screen-md flex flex-grow flex-col items-center ${textStart ? 'text-start' : 'text-center'} ${!(noPadding || borderless) && 'p-5'} gap-2` }, { children: children })) })) }))] })));
}
